import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ROLES } from 'src/constants/roles';
import { getPostLoginPath } from 'src/utils/navigation';

function SuperAdminGuard({ children }) {
  const { user } = useSelector(state => state.account);

  if (!user) {
    return <Redirect to='/login' />;
  }

  if (user.change_password) {
    return <Redirect to='/change-password' />;
  }

  if (user.role !== ROLES.superAdmin) {
    return <Redirect to={getPostLoginPath(user)} />;
  }

  return children;
}

SuperAdminGuard.propTypes = {
  children: PropTypes.any
};

export default SuperAdminGuard;
